module.exports = __webpack_public_path__ + "media/images/application/schema/logo-cde18379720ec2bbd89774ce39d51cca.png";